import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    MAT_LEGACY_TOOLTIP_DEFAULT_OPTIONS as MAT_TOOLTIP_DEFAULT_OPTIONS,
    MatLegacyTooltipDefaultOptions as MatTooltipDefaultOptions,
} from '@angular/material/legacy-tooltip';
import { FormaterPipe } from '@pipes/formater/formater.pipe';
import { FormatterModule } from '@pipes/formater/formatter.module';
import { SanitizeHtmlPipe } from '@pipes/sanitize/sanitize.pipe';
import { TruncatePipe } from '@pipes/truncate/truncate.pipe';
import { SignAppService } from '@services/sign.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppHttpInterceptor } from './app-http.inteceptor';
import { CustomMaterialModule } from './material.module';

const TOOLTIP_DEFAULT_OPTIONS: MatTooltipDefaultOptions = {
    showDelay: 500,
    hideDelay: 0,
    touchendHideDelay: 500,
    disableTooltipInteractivity: true,
};

@NgModule({
    imports: [
        CommonModule,
        CustomMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        NgxSpinnerModule,
        FlexLayoutModule,
        DragDropModule,
        ClipboardModule,
        TruncatePipe,
        FormatterModule,
        SanitizeHtmlPipe,
    ],
    exports: [
        CommonModule,
        CustomMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        NgxSpinnerModule,
        FlexLayoutModule,
        DragDropModule,
        FormaterPipe,
        SanitizeHtmlPipe,
        ClipboardModule,
        TruncatePipe,
        FormatterModule,
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
        { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: TOOLTIP_DEFAULT_OPTIONS },
        SignAppService,
    ],
})
export class GlobalModule {}
